module.exports = __webpack_public_path__ + "static/media/gestoria_rojo.bf12976a.svg";